import { makeStyles } from "@material-ui/core/styles";
import { toolbarHeight } from "components/app/Styles";
import theme from "theme";
export const filterContainerHeight = 0;
export const chartTitleHeight = 33;
export const chartTitleHeightResponsive = 50;
export const aboutDrawerWidth = 345;
export const chartDrawerWidth = 390;
export const chartTogglebarWidth = 68;
export const aboutTogglebarWidth = 68;

const useStyles = makeStyles(
  {
    "@global": {
      html: {
        height: "100%",
      },
      body: {
        margin: "0",
        height: "100%",
        fontFamily: "Arial, sans-serif",
      },
    },
    filter: {
      background: "#FFFFFF",
    },
    notSelectedFilter: {
      color: "#C0C0C0",
      fontStyle: "italic",
      background: "#FFFFFF",
    },
    menuItemRoot: {
      // width: 400,
    },
    filterSelect: {
      width: 250,
    },
    filterSelectResponsive: {
      width: "40%",
    },
    map: {
      height: `calc(100vh - ${toolbarHeight}px - ${filterContainerHeight}px)`,
      [theme.breakpoints.down("md")]: {
        height: `calc(100vh - ${toolbarHeight}px - ${chartTogglebarWidth}px - ${chartTogglebarWidth}px)`,
      },
    },
    mapArea: {
      "& .info": {
        padding: "15px",
        font: "0.8em Arial, Helvetica, sans-serif",
        background: "rgba(255, 255, 255, 1)",
        boxShadow: "0 0 15px rgba(0, 0, 0, 0.2)",
        borderRadius: "15px",
      },
      "& .infoCity": {
        padding: "6px 19px 5px 19px",
        font: "0.8em Arial, Helvetica, sans-serif",
        background: "rgba(255, 255, 255, 1)",
        boxShadow: "0 0 15px rgba(0, 0, 0, 0.2)",
        borderRadius: "15px",
        height: "10vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
      },
      "& .legendTitle": {
        // font: "normal normal bold 1.1em/30px Arial",
        fontFamily: "Arial",
        fontSize: "14px",
        fontWeight: "bold",
        color: "#2F2F2F",
      },
      "& .legend": {
        lineHeight: "16px",
        left: "20px",
      },
      "& .legend i": {
        width: "16px",
        height: "16px",
        float: "left",
        marginRight: "13px",
        opacity: "1",
      },
      "& .legendLabel": {
        // font: "normal normal normal 1.2em/16px Arial",
        fontFamily: "Arial",
        fontSize: "16px",
        color: "#2F2F2F",
      },
      "& .leaflet-top": {
        // ensure leaflet controls on top appear below the title
        // the chartheader has a padding of 50, so we add 55
        // top: `${chartTitleHeight + 55}px`,
        [theme.breakpoints.down("md")]: {
          top: chartTitleHeight,
        },
      },
      "& .leaflet-top.leaflet-left": {
        // changes zIndex so legend appears below chart drawer
        zIndex: 451,
      },
      "& .leaflet-bottom.leaflet-left": {
        // changes zIndex so legend appears below chart drawer
        width: "100%",
        display: "flex",
        justifyContent: "center",
        // "& .leaflet-control": {
        //   width: "100%",
        // }
      },
      "& .leaflet-popup-content p": {
        margin: "0.3em 0",
      },
      "& .leaflet-control-container": {
        // position: 'relative !important',
      },
    },
    mapAreaResponsive: {
      "& .info": {
        padding: "6px 19px 5px 19px",
        font: "0.8em Arial, Helvetica, sans-serif",
        background: "rgba(255, 255, 255, 1)",
        boxShadow: "0 0 15px rgba(0, 0, 0, 0.2)",
        borderRadius: "15px",
      },
      "& .infoCity": {
        padding: "6px 19px 5px 19px",
        font: "0.8em Arial, Helvetica, sans-serif",
        background: "rgba(255, 255, 255, 1)",
        boxShadow: "0 0 15px rgba(0, 0, 0, 0.2)",
        borderRadius: "15px",
        height: "10vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
      },
      "& .legendTitle": {
        // font: "normal normal bold 1.1em/30px Arial",
        fontFamily: "Arial",
        fontSize: "14px",
        fontWeight: "bold",
        color: "#2F2F2F",
      },
      "& .legend": {
        lineHeight: "16px",
        left: "20px",
      },
      "& .legend i": {
        width: "16px",
        height: "16px",
        float: "left",
        marginRight: "13px",
        opacity: "1",
      },
      "& .legendLabel": {
        // font: "normal normal normal 1.2em/16px Arial",
        fontFamily: "Arial",
        fontSize: "16px",
        color: "#2F2F2F",
      },
      "& .leaflet-top": {
        // ensure leaflet controls on top appear below the title
        // the chartheader has a padding of 50, so we add 55
        top: `${chartTitleHeightResponsive + 30}px`,
      },
      "& .leaflet-top.leaflet-left": {
        // changes zIndex so legend appears below chart drawer
        zIndex: 451,
      },
      "& .leaflet-bottom.leaflet-left": {
        // changes zIndex so legend appears below chart drawer
        width: "100%",
        // "& .leaflet-control": {
        //   width: "100%",
        // }
      },
      "& .leaflet-popup-content": {
        lineHeight: "1.0",
      },
      "& .leaflet-popup-content p": {
        margin: "1em 0",
      },
    },
    mapFilterGrid: {
      width: "120%",
      // marginTop: "30px",
      paddingLeft: "55px",
      display: "flex",
      justifyContent: "space-between",
      [theme.breakpoints.down("md")]: {
        paddingLeft: "0px",
      },
    },
    mapFilterChips: {
      background: "#FFFFFF",
      borderRadius: "40px",
      cursor: "pointer",
      height: "40px",
      padding: "0 12px",
    },
    mapFilterChipIcon: {
      height: "18px",
      marginRight: "10px",
      paddingLeft: "20px",
      [theme.breakpoints.down("md")]: {
        height: "14px",
      },
    },
    mapFilterChipLabel: {
      color: "#757575",
      fontSize: "15px",
      [theme.breakpoints.down("md")]: {
        fontSize: "12px",
      },
    },

    mapSliderContainer: {
      backgroundColor: "#FFFFFF ",
      boxShadow: "0px 3px 6px #00000029",
      padding: "8px 30px 8px 30px",
      border: "1px solid #E0E0E0",
      borderRadius: "15px",
      height: "60px",
      width: "40vw",
      display: "block",
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
    sliderTitle: {
      color: "#2F2F2F",
      // display: "block",
      font: "normal normal bold 13px/18px Arial",
      display: "flex",
      justifyContent: "center",
      // marginBottom: "12px",
      [theme.breakpoints.down("xl")]: {
        font: "normal normal bold 13px/18px Arial",
      },
      [theme.breakpoints.down("lg")]: {
        font: "normal normal bold 12px/16px Arial",
      },
    },
    sliderRail: {
      backgroundColor: "#C4C4C4",
      height: "7px",
    },
    slider: {
      color: "#9CC9F5",
      marginTop: "4px",
    },
    sliderVertical: {
      "&.MuiSlider-root": {
        height: "80% ",
        padding: "0 45%",
      },
      "&.MuiSlider-marked": {
        marginRight: "0px",
      },
      "& .MuiSlider-rail": {
        width: "5px",
        borderRadius: 4,
      },
      "& .MuiSlider-track": {
        width: "5px",
        borderRadius: 4,
      },
    },
    sliderValueLabel: {
      display: "none",
    },
    sliderThumb: {
      height: 15,
      width: 15,
      border: "2px solid currentColor",
      marginTop: -5,
    },
    sliderLabel: {
      font: "1em",
      display: "flex",
      justifyContent: "center",
    },
    sliderMark: {
      backgroundColor: "#2F2F2F",
      height: "7px",
      width: "7px",
      borderRadius: "3.5px",
    },
    sliderTrack: {
      height: "7px",
    },
  },
  { index: 999 }
);

export default useStyles;
